import {apolloClient} from '@/plugins/apollo'
import gql from 'graphql-tag'
import {setIntervalAsync} from 'set-interval-async/dynamic'
import {clearIntervalAsync} from 'set-interval-async'
import moment from "moment/moment";

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export class GraphqlUpdater {
    // due to history reasons
    // fetchQuery and fetchUpdateQuery are the same now
    constructor(options) {
        this.targetObjIdsGetter = options.targetObjIdsGetter
        this.fetchQuery = options.fetchQuery
        this.fetchUpdateQuery = options.fetchUpdateQuery
        this.updatedDataSetter = options.updatedDataSetter
        this.updatedDataSetterAsync = options.updatedDataSetterAsync
        this.autoUpdatePeriodMs = options.autoUpdatePeriodMs
        this.name = options.name

        this.intervalHandler = null
        this.started = false
        this.lastUpdateTs = null
        this.lastFetchedIds = []
        this.lastFetchedObjects = {}
        this.doing_step = false
    }


    async _doStep(forceRunFlag) {
        if(!document.hidden || forceRunFlag) {
            while (this.doing_step)
                await sleep(300)

            this.doing_step = true

            try {
                let targetObjIds = await this.targetObjIdsGetter()

                let objsForFullFetchIds = targetObjIds.filter(value => !this.lastFetchedIds.includes(value))
                let objsForUpdateIds = targetObjIds.filter(value => this.lastFetchedIds.includes(value))

                let operationName = this.fetchUpdateQuery.definitions[0].name.value

                let resUpdate = {}
                let resUpdateArray = []
                if (objsForUpdateIds.length) {
                    let qResUpdate = await apolloClient.query({
                        query: this.fetchUpdateQuery,
                        variables: {
                            updatedTsGreaterThen: this.lastUpdateTs,
                            ids: objsForUpdateIds,
                        }
                    })
                    resUpdateArray = qResUpdate.data[operationName]
                    for (const obj of resUpdateArray) {
                        resUpdate[obj.id] = obj
                    }
                }


                let resFetch = {}
                let resFetchArray = []
                if (objsForFullFetchIds.length) {
                    let qResFetch = await apolloClient.query({
                        query: this.fetchQuery,
                        variables: {
                            ids: objsForFullFetchIds
                        }
                    })
                    resFetchArray = qResFetch.data[operationName]
                    for (const obj of resFetchArray) {
                        resFetch[obj.id] = obj
                    }
                }


                if (resUpdateArray.length) { // noinspection JSUnresolvedVariable
                    this.lastUpdateTs = resUpdateArray[resUpdateArray.length - 1].updatedAt
                } else if (resFetchArray.length) { // noinspection JSUnresolvedVariable
                    this.lastUpdateTs = resFetchArray[resFetchArray.length - 1].updatedAt
                }

                let lastFetchedObjects = {}
                for (let objId of targetObjIds) {
                    if (objId in resUpdate)
                        lastFetchedObjects[objId] = resUpdate[objId]
                    else if (objId in resFetch)
                        lastFetchedObjects[objId] = resFetch[objId]
                    else if (objId in this.lastFetchedObjects)
                        lastFetchedObjects[objId] = this.lastFetchedObjects[objId]
                }

                let resObjIds = []
                for (const id of targetObjIds) {
                    if (id in lastFetchedObjects)
                        resObjIds.push(id)
                }

                this.lastFetchedObjects = lastFetchedObjects
                this.lastFetchedIds = resObjIds

                if (this.updatedDataSetter)
                    this.updatedDataSetter(this.lastFetchedObjects, this.lastFetchedIds)
                else
                    await this.updatedDataSetterAsync(this.lastFetchedObjects, this.lastFetchedIds)
            } catch (e) {
                try {
                    await logger.exception(`Update loop exception (${this.name})`, e)
                    // eslint-disable-next-line no-empty
                } catch (e) {
                }
            }
            this.doing_step = false
        }
    }

    async start(doDelayOnStart, fetchedObjects, lastUpdateTs) {
        if (fetchedObjects) {
            this.lastFetchedObjects = fetchedObjects
            this.lastFetchedIds = Object.keys(fetchedObjects)
        }
        if (lastUpdateTs) {
            this.lastUpdateTs = lastUpdateTs
        }
        if (!doDelayOnStart)
            await this.forceRun()
        if (this.started)
            throw Error('GraphqlUpdater already have been started')
        let t = this
        this.intervalHandler = setIntervalAsync(async function () {
            await t._doStep()
        }, this.autoUpdatePeriodMs)
        this.started = true
    }

    async stop() {
        if (this.started) {
            await clearIntervalAsync(this.intervalHandler)
            this.intervalHandler = null
            this.started = false
        }
    }

    async forceRun() {
        let started_flag = this.started
        if (started_flag)
            await this.stop()
        await this._doStep(true)
        if (started_flag) {
            await this.start(true)
        }
    }
}


export function getQueries(queryName, typeName, queryBody) {
       let queryTemplate = `
            query ${queryName} ($ids: [ID]!, $updatedTsGreaterThen: DateTime) {
                ${queryName}(ids: $ids, updatedTsGreaterThen: $updatedTsGreaterThen) {
                    [body]
                }
            }
        `
    let fetchQuery = queryTemplate.replace('[body]', queryBody)
    return {
        fetchQuery,
        queryBody
    }
}

export function makeId(length) {
    let result = '';
    let characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}


export let clientId
if ('clientId' in localStorage) {
    clientId = localStorage.getItem('clientId');
} else {
    clientId = makeId(7)
    localStorage.setItem('clientId', clientId)
}
export const clientType = 'Browser'

export class Logger {
    levels = {
        'CRITICAL': 50,
        'ERROR': 40,
        'WARNING': 30,
        'INFO': 20,
        'DEBUG': 10,
        'NOTSET': 0
    }

    constructor(level, log_to_console) {
        if (!(level in this.levels))
            throw Error(`Wrong logger level ${level}`)
        this.levelStr = level

        this.levelInt = this.levels[this.levelStr]
        this.log_to_console = log_to_console
    }

    async log(level, msg) {
        if (this.levels[level] >= this.levelInt) {
            if (this.log_to_console) {
                console.log(`${new Date()} cleintID-${clientId} LOGGER ${level} ${window.location.href}: ${msg}`)
            }
            await apolloClient.mutate({
                mutation: gql`
                    mutation log ($message: String!, $jsLogCallStackTrace: String, $url: String){
                        log(level: "${level}", message: $message, jsLogCallStackTrace: $jsLogCallStackTrace, url: $url) {
                            success
                        }
                    }
                `,
                variables: {
                    message: msg,
                    jsLogCallStackTrace: Error().stack,
                    url: window.location.href
                }
            })
        }
    }

    async exception(msg, exc) {
        msg = `${msg}\n${exc.stack}`
        await this.log('ERROR', msg)
    }

    async critical(msg) {
        await this.log('CRITICAL', msg)
    }

    async error(msg) {
        await this.log('ERROR', msg)
    }

    async warning(msg) {
        await this.log('WARNING', msg)
    }

    async info(msg) {
        await this.log('INFO', msg)
    }

    async debug(msg) {
        await this.log('DEBUG', msg)
    }
}

export let logger = new Logger(process.env.VUE_APP_LOG_LEVEL, true)


export function getDomPath(el) {
    let stack = [];
    while (el.parentNode != null) {
        let sibCount = 0;
        let sibIndex = 0;
        for (let i = 0; i < el.parentNode.childNodes.length; i++) {
            let sib = el.parentNode.childNodes[i];
            if (sib.nodeName === el.nodeName) {
                if (sib === el) {
                    sibIndex = sibCount;
                }
                sibCount++;
            }
        }
        if (el.hasAttribute('id') && el.id !== '') {
            stack.unshift(el.nodeName.toLowerCase() + '#' + el.id);
        } else if (sibCount > 1) {
            stack.unshift(el.nodeName.toLowerCase() + ':eq(' + sibIndex + ')');
        } else {
            stack.unshift(el.nodeName.toLowerCase());
        }
        el = el.parentNode;
    }

    return stack.slice(1); // removes the html element
}


export function printSeparated(obj, obj2, dontStringify) {
    if (!dontStringify) {
        obj = JSON.stringify(obj)
        if (obj2 !== undefined)
            obj2 = JSON.stringify(obj2)
    }
    let str = obj
    if (obj2)
        str = str + ' ' + obj2
    console.log('!!!!!!!!!!!!!!!!\n' + str + '\n!!!!!!!!!!!!!!!!!!!!')
}


export function camelToUnderscore(key) {
    let result = key.replace( /([A-Z])/g, " $1" );
    return result.split(' ').join('_').toLowerCase();
}


export function isTouchDevice() {
    return window.matchMedia("(pointer: coarse)").matches // possibly there is issues at some PCs with FF
}

export function getDateFormat() {
    const sample = window.Intl ? new Intl.DateTimeFormat(undefined,
        {
            numberingSystem: 'latin',
            calendar: 'gregory'
        }).format(new Date(1970, 11, 31)) : '';

    let mm = 0,
        mi = sample.indexOf(12);
    let dd = 1,
        di = sample.indexOf(31);
    let yy = 2,
        yi = sample.indexOf(1970);

    // IE 10 or earlier, iOS 9 or earlier, non-Latin numbering system
    // or non-Gregorian calendar; fall back to mm/dd/yyyy
    if (yi >= 0 && mi >= 0 && di >= 0) {
        mm = (mi > yi) + (mi > di);
        dd = (di > yi) + (di > mi);
        yy = (yi > mi) + (yi > di);
    }

    let r = [];
    r[yy] = 'YYYY';
    r[mm] = 'MM';
    r[dd] = 'DD';

    return r.join(sample.match(/[-.]/) || '/');
}

export function formatDateTime(dateStr) {
    return moment.utc(dateStr).local().format(`${getDateFormat()} HH:mm`)
}